// @flow
import * as React from "react";

import ThemeContext from "contexts/ThemeContext";
import type { ThemeContextType } from "contexts/ThemeContext";

export function useTheme(): ThemeContextType {
  const context = React.useContext(ThemeContext);

  if (context === null) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }

  return context;
}
